export default "__VITE_ASSET__60d7d389__"